module.exports = __webpack_public_path__ + "img/滑块3.c8415051.jpg";